import { ENTITY_LIMITS_TABLE_COPY } from '@sonar-software/sonar-ts-constants';

import { ColumnsType, ColumnType } from 'antd/es/table';

export type EntityLimit = {
	id: number;
	item: string;
	limit: number;
	percentUsed: number;
	title: string;
	usage: number;
};

type ColumnDefinition = ColumnType<EntityLimit>;

function getItemColumn(): ColumnDefinition {
	return {
		dataIndex: 'item',
		defaultSortOrder: 'ascend',
		key: 'item',
		sorter: (a, b) => a.item.localeCompare(b.item),
		title: ENTITY_LIMITS_TABLE_COPY.ITEM
	};
}

function getUsageColumn(): ColumnDefinition {
	return {
		dataIndex: 'usage',
		sorter: (a, b) => a.usage - b.usage,
		title: ENTITY_LIMITS_TABLE_COPY.USAGE
	};
}

function getLimitColumn(): ColumnDefinition {
	return {
		dataIndex: 'limit',
		sorter: (a, b) => a.limit - b.limit,
		title: ENTITY_LIMITS_TABLE_COPY.LIMIT
	};
}

function getPercentUsedColumn(): ColumnDefinition {
	return {
		dataIndex: 'percentUsed',
		render: (value) => `${value}%`,
		sorter: (a, b) => a.percentUsed - b.percentUsed,
		title: ENTITY_LIMITS_TABLE_COPY.PERCENT_USED
	};
}

export function getColumns(): ColumnsType<EntityLimit> {
	return [
		getItemColumn(),
		getUsageColumn(),
		getLimitColumn(),
		getPercentUsedColumn()
	];
}
